import bg from './styrelsen-5.webp';
import './App.css';

function App() {
  return (
    <div className="App">          
      <div className='overlay'>
        <h1>Portalen är under konstruktion . . .</h1>
        <div>
          <p>Letar du efter </p>
          <a            
            href="https://drive.google.com/drive/folders/1TPL7TLexw9zb-7u7gSslXG0aQ43JaZN_?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            dropboxen?
          </a> 
        </div>    
      </div>  
    </div>
  );
}

export default App;
